













import {
  IOvertimeRequest,
  ITimeOffRequest,
  IVacationCarryOverRequest
} from '@/models';

import Vue, { PropType } from 'vue';
export default Vue.extend({
  name: 'RequestStatusDisplay',

  props: {
    request: {
      type: Object as PropType<
        IOvertimeRequest | IVacationCarryOverRequest | ITimeOffRequest
      >,
      required: true
    }
  }
});
